import { ReactNode } from 'react'
import localFont from 'next/font/local'

import { BaseFontProvider } from './base-font-provider'

// Self-hosted (latin subset) instead of next/font/google so a cold `next build`
// has no build-time dependency on Google Fonts. Heebo is a variable font: one
// woff2 covers the whole weight range. Re-vendor via
// scripts/vendor-google-fonts.mjs.
const heebo = localFont({
  src: '../../public/fonts/heebo/Heebo-variable.woff2',
  weight: '300 900',
  display: 'swap',
})

export const HeeboProvider = ({ children }: { children: ReactNode }) => {
  return <BaseFontProvider font={heebo}>{children}</BaseFontProvider>
}
